
const store = require('../store/index');
const axios = require("axios");
const VueCookies = require("vue-cookies")
const md5 = require("md5");

export const getCookie = () =>
{
  const CookieID = "tracking"
  const Cookie   = VueCookies.get(CookieID);
  if(Cookie === null)
  {
      const RandomHash = md5(Math.random().toString(12).slice(2).slice(0,14)+"."+Date.now().toString().slice(-9, -1));
      VueCookies.set(CookieID,RandomHash,"2d");
      return RandomHash;
  }

  return Cookie;
}

export const reloadCookie = () => {
  const CookieID = "tracking"

    const RandomHash = md5(Math.random().toString(12).slice(2).slice(0,14)+"."+Date.now().toString().slice(-9, -1));
    VueCookies.set(CookieID,RandomHash,"2d");
    return RandomHash;
}

export const getCookieByName = CookieName => VueCookies.get(CookieName);

export const getApiURL = () =>
{
  return process.env.VUE_APP_API_URL
}

export const getApiLogisticsURL = () =>
{
  return process.env.VUE_APP_API_LOGISTICS_URL
}

export const getPathURL = () =>
{
  return process.env.VUE_APP_PATH_URL}

export const getSession = () => 
{   
  var baseURL = process.env.VUE_APP_BASE_URL_SESSION;

  const Session = axios.default.create( { baseURL } );

  Session.interceptors.response.use(response => 
  {
    const {data} = response;
    if(data.hasOwnProperty("valid")){
        if(data.valid === false){
          console.log(data)
            store.default.commit("Misc/setError",data);
        }
    }
    return response;    
  }, error =>
  {
    return Promise.reject(error);
  });

  return Session;
}

export const getSessionEcommerce = () => 
{   
  var baseURL = process.env.VUE_APP_BASE_URL_SESSION_ECOMMERCE;

  const Session = axios.default.create( { baseURL } );

  Session.interceptors.response.use(response => 
  {
    const {data} = response;
    if(data.hasOwnProperty("valid")){
        if(data.valid === false){
          console.log(data)
            store.default.commit("Misc/setError",data);
        }
    }
    return response;    
  }, error =>
  {
    throw error;
  });

  return Session;
}

export const getEdad = Nacimiento => 
{
    var fecha = new Date();
    var fechaNacimiento = new Date(Nacimiento);
    if(Nacimiento === undefined)
    {
        return undefined;
    }
    var edad = fecha.getFullYear() - fechaNacimiento.getFullYear();
    var m = fecha.getMonth() - fechaNacimiento.getMonth();
    if (m < 0 || (m === 0 && fecha.getDate() < fechaNacimiento.getDate())) 
      edad--;
    
    if(edad < 0)
    {
        return undefined;
    }
    return edad;
}

export const delay = segundos => new Promise(res => setTimeout(res, segundos * 1000));

export const getPrecio = Edad =>
{
    const {Resources} = store.default.state.Misc;
    
    if(Resources)
    {
        const {prices} = Resources;

        var Price = prices.find(price => 
        {
            if(Number(price.age_from) <= Edad && Number(price.age_to) >= Edad)
            {
                return price;
            }
        });

        return Price;
    }
}

export const getPrecioPlus = (Edad,isAlone) =>
{
  const {Resources} = store.default.state.Misc;
  const { Members } = store.default.state.UrgPlus;

  const {plus_prices} = Resources;

  const filteredPrices = plus_prices.filter(price => (Number(price.age_from) <= Edad && Number(price.age_to) >= Edad));  

  if(filteredPrices.length === 0)
    throw new Error("No se encontró precio para la edad ingresada");

  if(filteredPrices.length === 1)
    return filteredPrices[0];


  const AloneTableValue = isAlone ? "1" : "0";

  const correctPrice = filteredPrices.find(price => price.alone === AloneTableValue);

  return correctPrice; 
}
export const getPrecioConecta = (productId, Edad, isAlone = false) => {
  const { Resources } = store.default.state.Misc;
  const { conecta_prices, plus_prices } = Resources;

  // Filtra por productID
  const filteredConecta = conecta_prices.filter(price => Number(price.product) == Number(productId));
  if (filteredConecta.length === 0)
    throw new Error("No se encontró precio para el producto ingresado");

  const AloneTableValue = isAlone ? "1" : "0";
  const conectaPrice = filteredConecta.find(price => price.alone === AloneTableValue) || filteredConecta[0];

  // Suma los precios
  return {
    ...conectaPrice,
    price: Number(conectaPrice.price) 
  };
}

export const getFormData = (object) => 
{
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key]));
    return formData;
}

export const FocusDiv = ID =>
{
    const element = document.getElementById(ID);
    if (!element) return;
    window.scrollTo({
        'behavior': 'smooth',
        'left': 0,
        'top': element.offsetTop
    });
}

export const getDocumentoID = (doc) => {
  const MAP = { DNI: 1, LC: 2, LE: 3, Pasaporte: 4, 'Cédula': 5 };

  // Si ya viene como número o string numérica, úsalo tal cual
  const n = Number(doc);
  if (!Number.isNaN(n) && n > 0) return n;

  // Si viene como label, mapéalo (case-insensitive y sin tildes opcional)
  const key = String(doc).trim();
  return MAP[key] ?? 0;   // 0 si no matchea
};


export const getGeneroID = Genero =>
{
    const Generos=['Masculino','Femenino','Otro'];
    return Generos.indexOf(Genero)+1;
}

export const getZoneObject = ID =>
{
    const {zones} = store.default.state.Misc.Resources;
    const Zone = zones.find(zone => String(zone.id).toUpperCase() === String(ID).toUpperCase());
    if(Zone)
    {
        return Zone;
    }
}

export const getZone = ID =>
{
    const {zones} = store.default.state.Misc.Resources;
    const Zone = zones.find(zone => String(zone.id).toUpperCase() === String(ID).toUpperCase());
    if(Zone)
    {
        return String(Zone.title).toLocaleLowerCase().charAt(0).toUpperCase() + String(Zone.title).toLocaleLowerCase().slice(1);
    }
}

export const verifyOrder = async () =>
{
   
    try 
    {
        //step 3
        const Session        = getSession();
        const CookieTracking = $cookies.get("tracking");

        const {Members,Nombre,Apellido,Email,Tipo,Documento,Genero,Nacimiento,Celular,Direccion} = store.default.state.Personas;
    
        var formDataThrid = new FormData();
        formDataThrid.append("step", 3);
        formDataThrid.append("productid", 1);

        if(Members.length === 0)
        {
            formDataThrid.append("body[extra_affiliates]", 0);
            formDataThrid.append("response", "");
        }
        else
        {
            const LastMember = Members[Members.length-1];
            const LastMemberEdad = getEdad(LastMember.Nacimiento);

            formDataThrid.append("body[firstname]", LastMember.Nombre);
            formDataThrid.append("body[lastname]", LastMember.Apellido);
            formDataThrid.append("body[document_type]", getDocumentoID(LastMember.Documento));
            formDataThrid.append("body[document_number]", LastMember.Documento);
            formDataThrid.append("body[gender]", getGeneroID(LastMember.Genero));
            formDataThrid.append("body[email]", LastMember.Email);
            formDataThrid.append("body[zone]", getZone(LastMember.Direccion.Localidad));
            formDataThrid.append("body[search_address]", "");
            formDataThrid.append("body[search_number]", "");
            formDataThrid.append("body[address]", `${LastMember.Direccion.Calle} ${LastMember.Altura} - ${LastMember.Direccion.Piso}`);
            formDataThrid.append("body[address_number]", LastMember.Direccion.Altura);
            formDataThrid.append("body[address2]", "");
            LastMember.Direccion.Barrio ? formDataThrid.append("body[neighborhood]", LastMember.Direccion.Barrio) : formDataThrid.append("body[neighborhood]", "");
            formDataThrid.append("body[key]", 1);
            formDataThrid.append("body[birthday]", LastMember.Nacimiento);
            formDataThrid.append("body[phone]", LastMember.Celular);
            formDataThrid.append("body[age]", LastMemberEdad);
            formDataThrid.append("body[route]", LastMember.Direccion.Calle);
            formDataThrid.append("body[city]", LastMember.Direccion.Localidad.title);
            formDataThrid.append("body[coords][lat]", LastMember.Direccion.Latitud);
            formDataThrid.append("body[coords][lng]", LastMember.Direccion.Longitud);

            const PrecioLastMember = getPrecio(LastMemberEdad);
            formDataThrid.append("body[price]", PrecioLastMember.price);
            formDataThrid.append("body[discount]", `${PrecioLastMember.discount}%`);
            formDataThrid.append("body[total]", PrecioLastMember.price);
            formDataThrid.append("body[discount_comment]", PrecioLastMember.discount_comment);
            formDataThrid.append("body[price_extra_comments]", PrecioLastMember.extra_comments);
            formDataThrid.append("body[document_type_title]", PrecioLastMember.Tipo);
            formDataThrid.append("response[valid]", true);
            formDataThrid.append("response[msg]", "");        
        }

        const PeticionThridStep = await Session.post(`/tracking/${CookieTracking}`,  formDataThrid);

        //step 4
        const TipoDocumento = getDocumentoID(Tipo);
        const GeneroID = getGeneroID(Genero);
        const Edad = getEdad(Nacimiento);
        const Zona = getZone(Direccion.Localidad);
        const Precio = getPrecio(Edad);


        var formData = new FormData();

        formData.append('step', '4');
        formData.append('productid', '1');
        formData.append('body[people][0][firstname]', Nombre);
        formData.append('body[people][0][lastname]', Apellido);
        formData.append('body[people][0][email]', Email);
        formData.append('body[people][0][document_type]', TipoDocumento);
        formData.append('body[people][0][document_number]', Documento);
        formData.append("body[people][0][key]", 0);
        formData.append("body[people][0][gender]", GeneroID);
        formData.append("body[people][0][birthday]", Nacimiento);
        formData.append("body[people][0][age]", Edad);
        formData.append("body[people][0][phone]", Celular);
        formData.append("body[people][0][route]", Direccion.Calle);
        formData.append("body[people][0][address]", `${Direccion.Calle} - ${Direccion.Altura} - ${Direccion.Piso}`);
        formData.append("body[people][0][address_number]", Direccion.Altura);
        formData.append("body[people][0][city]", Direccion.Localidad.title);
        formData.append("body[people][0][zone]", Zona); 
        formData.append("body[people][0][coords][lat]", Direccion.Latitud); 
        formData.append("body[people][0][coords][lng]", Direccion.Longitud); 
        formData.append("body[people][0][price]", Precio.price); 
        formData.append("body[people][0][discount]", `${Precio.discount}`); 
        formData.append("body[people][0][total]", Precio.price); 
        formData.append("body[people][0][discount_comment]", Precio.discount_comment); 
        formData.append("body[people][0][price_extra_comments]", Precio.extra_comments); 
        formData.append("body[people][0][document_type_title]", Tipo);
        
        for (let index = 0; index < Members.length; index++) 
        {
            const Member = Members[index];
            const TipoDocumentoMember = getDocumentoID(Member.Tipo);
            const GeneroIDMember = getGeneroID(Member.Genero);
            const MemberEdad = getEdad(Member.Nacimiento);
            const MemberZona = getZone(Member.Direccion.Localidad);
            const MemberPrecio = getPrecio(MemberEdad);
            const IndexMember = index+1;

            formData.append(`body[people][${IndexMember}][firstname]`, Member.Nombre);
            formData.append(`body[people][${IndexMember}][lastname]`, Member.Apellido);
            formData.append(`body[people][${IndexMember}][document_type]`, TipoDocumentoMember);
            formData.append(`body[people][${IndexMember}][document_number]`, Member.Documento);
            formData.append(`body[people][${IndexMember}][gender]`, GeneroIDMember);
            formData.append(`body[people][${IndexMember}][email]`, Member.Email);
            formData.append(`body[people][${IndexMember}][zone]`, MemberZona); 
            formData.append(`body[people][${IndexMember}][search_address]`, ``);
            formData.append(`body[people][${IndexMember}][search_number]`, ``);
            formData.append(`body[people][${IndexMember}][address]`, `${Member.Direccion.Calle} - ${Member.Direccion.Altura} - ${Member.Direccion.Piso}`);
            formData.append(`body[people][${IndexMember}][address_number]`, Member.Direccion.Altura);
            formData.append(`body[people][${IndexMember}][address2]`, ``);
            formData.append(`body[people][${IndexMember}][neighborhood]`, ``);
            formData.append(`body[people][${IndexMember}][key]`, IndexMember);
            formData.append(`body[people][${IndexMember}][birthday]`, Member.Nacimiento);
            formData.append(`body[people][${IndexMember}][phone]`, Member.Celular);
            formData.append(`body[people][${IndexMember}][age]`, MemberEdad);
            formData.append(`body[people][${IndexMember}][route]`, Member.Direccion.Calle); 
            formData.append(`body[people][${IndexMember}][city]`, Member.Direccion.Localidad.title);
            formData.append(`body[people][${IndexMember}][lat]`, Member.Direccion.Latitud);
            formData.append(`body[people][${IndexMember}][lng]`, Member.Direccion.Longitud);

            formData.append(`body[people][${IndexMember}][price]`, MemberPrecio.price);
            formData.append(`body[people][${IndexMember}][discount]`, `${MemberPrecio.discount}`);
            formData.append(`body[people][${IndexMember}][total]`, MemberPrecio.price);
            formData.append(`body[people][${IndexMember}][discount_comment]`, MemberPrecio.discount_comment);
            formData.append(`body[people][${IndexMember}][price_extra_comments]`, MemberPrecio.extra_comments);
            formData.append(`body[people][${IndexMember}][document_type_title]`, Member.Tipo);
        }

        const Total = store.default.getters.getTotal;

        formData.append("body[subtotal]", Total); 
        formData.append("body[discount]", 0); 
        formData.append("body[totalPersonDiscount]", `${Precio.discount}`); 
        formData.append("body[total]", Total); 
        formData.append("body[collect_people_data]", 1); 


        const PeticionFourthStep = await Session.post(`/tracking/${CookieTracking}`,  formData);

        if(PeticionThridStep.status === 200 && PeticionFourthStep.status === 200)
        return true;
        
        return false;   
    } catch (error) {
        console.log(error);
        return false;
    }
}

export const getZones = () =>
{
    const {zones} = store.default.state.Misc.Resources;
    return zones;
}

export const getPrecioByRange = RangeValue =>
{
    const {ap_prices} = store.default.state.Misc.Resources;
    return Number((ap_prices.find(precio => precio.title === RangeValue)).price);
}

export const getPrecioByUnit = (UnitValue,Empleados) =>
{
    const {ap_prices} = store.default.state.Misc.Resources;
    const PrecioUnidad  = Number( ap_prices.find(precio => precio.title === UnitValue).price );
    return Number(Empleados) * Number(PrecioUnidad);
}

export const buildFormData = (formData, data, parentKey) => 
{
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else {
      const value = data == null ? '' : data;
  
      formData.append(parentKey, value);
    }
}

export const getTotalPlus = () =>
{
    const {UrgPlus} = store.default.state;
    const state = UrgPlus;

    if(!state.Price)
    {
      return null;
    }
    const {price} = state.Price;

    if(!price)
    {
      return null;
    }

    var Total = 0;

    if(state.Price.discount !== "0.00")
    {
      Total += Number(price) - (Number(price) * (Number(state.Price.discount) / 100));
    }
    else
    {
      Total += Number(price);
    }

    Total = Math.ceil(Total);

    state.Members.forEach(member =>
    {
      if(member.Price.discount === "0.00")
      {
        Total += Math.ceil(Number(member.Price.price));
      }
      else
      {
        Total += (Math.ceil(Number(member.Price.price)) - (Math.ceil(Number(member.Price.price)) * (Number(member.Price.discount) / 100)));
      }
    })

    if(state.Cupon)
    {
      return Math.ceil(state.Cupon.totalWithGiftcard);
    }
    
    return Math.ceil(Total);

}

export const getTotal = () =>
{
    const {Personas} = store.default.state;
    const state = Personas;

    if(!state.Price)
    {
      return null;
    }
    const {price} = state.Price;

    if(!price)
    {
      return null;
    }

    var Total = 0;

    if(state.Price.discount !== "0.00")
    {
      Total += Number(price) - (Number(price) * (Number(state.Price.discount) / 100));
    }
    else
    {
      Total += Number(price);
    }

    Total = Math.ceil(Total);


    state.Members.forEach(member =>
    {
      if(member.Price.discount === "0.00")
      {
        Total += Math.ceil(Number(member.Price.price));
      }
      else
      {
        Total += (Math.ceil(Number(member.Price.price)) - (Math.ceil(Number(member.Price.price)) * (Number(member.Price.discount) / 100)));
      }
    });
    
    if(state.Cupon)
    {
      return Math.ceil(state.Cupon.totalWithGiftcard);
    }
    
    return Math.ceil(Total);
}

export const getFamilyDiscount = (length, gross_price) =>
{
    const {Resources} = store.default.state.Misc;
      
    if(Resources)
    {
        const {prices_group_discount} = Resources;

        var Price = prices_group_discount.find(price => 
        {

            if(Number(price.from) <= length && Number(price.to) >= length)
            {
              return price;
            }
        });

        return Price;
    }
}

export const getPrice = async members => {
  const { Resources } = store.default.state.Misc;
  const utmSourceExists = window.location.search.includes("utm_source=");
  
  var Pricing = {
    members: [],
    prices_group_discount: undefined,
    subtotal: 0,
    total: 0,
    discount: 0,
    comment: undefined
  };

  for (const member of members) {
    const { Edad } = member;
    const { plus_prices } = Resources;

    const age = Number(Edad);
    var Price = plus_prices.find(p =>
      Number(p.age_from) <= age && Number(p.age_to) >= age
    );
    //var Price = plus_prices.find(price => price.age_from <= Edad && price.age_to >= Edad);

    

    // if (utmSourceExists) {
    //   try {
    //     const url = new URL(window.location.href);
    //     const params = new URLSearchParams(url.search);
    //     const utmSource = params.get('utm_source');
    //     var promotion = false;

    //     // 👇 Await para que espere correctamente
    //     const response = await getSession().get(`/promotions/`);

    //     if (response.data.length > 0) {
    //       const validPromotions = response.data.filter(promotion => {
    //         const now = new Date();
    //         const startsAt = new Date(promotion.starts_at);
    //         const expiresAt = new Date(promotion.expires_at);
    //         return promotion.utm_source === utmSource && now >= startsAt && now <= expiresAt && promotion.status == '1';
    //       });

    //       if (validPromotions.length > 0) {
    //         promotion = true;
    //         const selectedPromotion = validPromotions[0];
    //         Price.discount = Number(selectedPromotion.discount);
    //         Price.discount_cbu = Number(selectedPromotion.discount_cbu);
    //         Price.discount_cc = Number(selectedPromotion.discount_cc);
    //         Price.discount_comment = selectedPromotion.discount_comment;
    //         Price.title = selectedPromotion.title;
    //         Price.utm_source = selectedPromotion.utm_source;
    //         Price.total = Number((Price.price - (Price.price * (Number(Price.discount) / 100))).toFixed(2))
    //         Price.total_cbu = Number(
    //           (Price.price - Price.price * (Price.discount_cbu / 100)).toFixed(2)
    //         );
    //         Price.total_cc = Number(
    //           (Price.price - Price.price * (Price.discount_cc / 100)).toFixed(2)
    //         );

    //       }
    //     }
    //   } catch (error) {
    //     console.error("Error obteniendo promociones:", error);
    //   }
    // }


    if (!Price) {
      var age_to_find_number = parseInt(Edad);
      var prices_found = plus_prices.filter(({ age_from, age_to }) => age_to_find_number >= parseInt(age_from) && age_to_find_number <= parseInt(age_to));
      Price = prices_found[0];
    } else {
      if (!utmSourceExists || !promotion) {
        Price = {
          price: Price.price,
          discount_cbu: Number(Price.discount_cbu),
          discount_cc: Number(Price.discount_cc),
          discount_comment: Price.discount_comment,
          extra_comments: Price.extra_comments,
          //total: Number((Price.price - (Price.price * (Number(Price.discount) / 100))).toFixed(2))
          total_cbu: Number((Price.price - Price.price * (Price.discount_cbu / 100)).toFixed(2)),
          total_cc: Number((Price.price - Price.price * (Price.discount_cc / 100)).toFixed(2)),
        };
      }
    }

    member.Price = Price;
    Pricing.members.push(member);
    Pricing.subtotal += Number(Price.total);
    
  }
  
  if (!utmSourceExists) {

    const DiscountGrouping = Resources.prices_group_discount.find(discount => discount.from <= Pricing.members.length && discount.to >= Pricing.members.length);


    Pricing.total = Number(Pricing.subtotal - (Pricing.subtotal * (Number(DiscountGrouping.discount) / 100))).toFixed(2);
    Pricing.discount_comment = Price.discount_comment;
    Pricing.discount = Number(DiscountGrouping.discount);
    Pricing.total_cbu = Price.total_cbu;
    Pricing.total_cc = Price.total_cc;
    Pricing.discount_cbu = Price.discount_cbu;
    Pricing.discount_cc = Price.discount_cc;
  } else {
    Pricing.utm_source = Price.utm_source;
    Pricing.title = Price.title;
    Pricing.discount = Price.discount;
    Pricing.comment = Price.discount_comment;
    Pricing.total_cbu = Price.total_cbu;
    Pricing.total_cc = Price.total_cc;
    Pricing.discount_cbu = Price.discount_cbu;
    Pricing.discount_cc = Price.discount_cc;
  }

  return Pricing;
}

// === helpers =========================
const pickPlusByAge = (plus_prices, age) =>
  plus_prices.find(p => Number(p.age_from) <= age && Number(p.age_to) >= age) || plus_prices[0];

const pickConectaByAgeAndProduct = (conecta_prices, age, productId) =>
  conecta_prices.find(p =>
    Number(p.product) === Number(productId) &&
    Number(p.age_from) <= age &&
    Number(p.age_to)   >= age
  ) || conecta_prices.find(p => Number(p.product) === Number(productId)) || conecta_prices[0];

// === cálculo simplificado ============
// Precio mensual final = (abono Conecta) + (abono Plus). Sin descuentos.
// El dispositivo se muestra APARTE (si 0 => "Incluido").
export const getPriceConecta = (members, productId) => {
  const { Resources } = store.default.state.Misc;
  const { conecta_prices } = Resources;

  const Pricing = {
    members: [],
    // totales mensuales (sin descuentos ni medios de pago)
    subtotal: 0,
    total: 0,
    // compat: dejamos estos campos iguales (no hay diferencia CBU/CC)
    total_cbu: 0,
    total_cc: 0,

    // dispositivo (se muestra aparte)
    device_label: Number(productId) == 1 ? 'Reloj' : 'Colgante',
    device_unit_price: 0,
    device_total: 0,

    // compat con UI anterior (solo por si los usás):
    total_reloj_cbu: 0,
    total_reloj_cc: 0,
    total_colgante_cbu: 0,
    total_colgante_cc: 0,

    // sin descuentos/promos
    discount: 0,
    discount_cbu: 0,
    discount_cc: 0,
    discount_comment: undefined
  };

  let monthlySum = 0;
  let deviceUnit = 0;

  for (const m of members) {
    const age = Number(m.Edad);
    const C = pickConectaByAgeAndProduct(conecta_prices, age, productId);

    const priceConecta = Number(C?.price || 0);
    const monthly      = Number((priceConecta).toFixed(2));

    // precio del dispositivo según producto
    deviceUnit = Number(
      Number(productId) == 1 ? (C?.reloj_price || 0) : (C?.colgante_price || 0)
    );

    // Guardamos por miembro (campos “compatibles” con tu UI actual)
    m.Price = {
      price_conecta: priceConecta,
      price:         monthly,    // total mensual por integrante
      total_cbu:     monthly,    // sin diferencia por medio de pago
      total_cc:      monthly,
      reloj_price:   Number(C?.reloj_price || 0),
      colgante_price:Number(C?.colgante_price || 0)
    };

    Pricing.members.push(m);
    monthlySum += monthly;
  }

  // totales mensuales (grupo)
  Pricing.subtotal = Number(monthlySum.toFixed(2));
  Pricing.total    = Pricing.subtotal;
  Pricing.total_cbu = Pricing.total; // compat
  Pricing.total_cc  = Pricing.total; // compat

  // Dispositivo mostrado aparte
  // Si necesitás cobrar 1 dispositivo por persona, cambiá a: deviceUnit * members.length
  Pricing.device_unit_price = deviceUnit;
  Pricing.device_total      = deviceUnit;

  // Compat con campos viejos (para no tocar el template):
  if (Number(productId) == 1) { // reloj
    Pricing.total_reloj_cbu    = Pricing.total + deviceUnit;
    Pricing.total_reloj_cc     = Pricing.total + deviceUnit;
    Pricing.total_colgante_cbu = Pricing.total;            // “Incluido”
    Pricing.total_colgante_cc  = Pricing.total;            // “Incluido”
  } else { // colgante
    Pricing.total_colgante_cbu = Pricing.total + deviceUnit; // normalmente 0
    Pricing.total_colgante_cc  = Pricing.total + deviceUnit; // normalmente 0
    Pricing.total_reloj_cbu    = Pricing.total;
    Pricing.total_reloj_cc     = Pricing.total;
  }

  return Pricing;
};

export const getDocumentoTitle = id => ['DNI','LC','LE','Pasaporte','Cédula'][Number(id)-1] || 'DNI';
export const getGeneroTitle = id => ['Masculino','Femenino','Otro'][Number(id)-1] || '';


export const GMAPKEY = process.env.VUE_APP_GMAPKEY